// API 설정 - 현재 호스트의 API 사용
const API_BASE_URL = window.location.origin;

export { API_BASE_URL };
